import { makeRoutePath } from 'lib/helpers/ServiceHelper';
import { ClientManager } from 'types/ClientManager.type';

import API from '../lib/API';
import { CreateClientManagerConsent } from './contracts/ClientManager.contract';

const ROUTE = '/v2/client-managers' as const;

/**
 * @service v2
 * @route /client-managers/:id/consents
 * @http POST
 */
export const createClientManagerConsent = (
    id: ClientManager.Model['id'],
    body: CreateClientManagerConsent.Body 
): Promise<CreateClientManagerConsent.Response> => {
    const routePath = makeRoutePath([ROUTE, id.toString(), 'consents']);

    return API.post(routePath, body);
};